/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// clang-format off
export {
  defineBase as ÉµdefineBase,
  defineComponent as ÉµdefineComponent,
  defineDirective as ÉµdefineDirective,
  definePipe as ÉµdefinePipe,
  defineNgModule as ÉµdefineNgModule,
  detectChanges as ÉµdetectChanges,
  renderComponent as ÉµrenderComponent,
  AttributeMarker as ÉµAttributeMarker,
  ComponentType as ÉµComponentType,
  ComponentFactory as ÉµRender3ComponentFactory,
  ComponentRef as ÉµRender3ComponentRef,
  DirectiveType as ÉµDirectiveType,
  RenderFlags as ÉµRenderFlags,
  directiveInject as ÉµdirectiveInject,
  injectAttribute as ÉµinjectAttribute,
  getFactoryOf as ÉµgetFactoryOf,
  getInheritedFactory as ÉµgetInheritedFactory,
  templateRefExtractor as ÉµtemplateRefExtractor,
  ProvidersFeature as ÉµProvidersFeature,
  InheritDefinitionFeature as ÉµInheritDefinitionFeature,
  NgOnChangesFeature as ÉµNgOnChangesFeature,
  LifecycleHooksFeature as ÉµLifecycleHooksFeature,
  NgModuleType as ÉµNgModuleType,
  NgModuleRef as ÉµRender3NgModuleRef,
  CssSelectorList as ÉµCssSelectorList,
  markDirty as ÉµmarkDirty,
  NgModuleFactory as ÉµNgModuleFactory,
  NO_CHANGE as ÉµNO_CHANGE,
  container as Éµcontainer,
  nextContext as ÉµnextContext,
  elementStart as ÉµelementStart,
  namespaceHTML as ÉµnamespaceHTML,
  namespaceMathML as ÉµnamespaceMathML,
  namespaceSVG as ÉµnamespaceSVG,
  element as Éµelement,
  listener as Éµlistener,
  text as Éµtext,
  embeddedViewStart as ÉµembeddedViewStart,
  query as Éµquery,
  registerContentQuery as ÉµregisterContentQuery,
  projection as Éµprojection,
  bind as Éµbind,
  interpolation1 as Éµinterpolation1,
  interpolation2 as Éµinterpolation2,
  interpolation3 as Éµinterpolation3,
  interpolation4 as Éµinterpolation4,
  interpolation5 as Éµinterpolation5,
  interpolation6 as Éµinterpolation6,
  interpolation7 as Éµinterpolation7,
  interpolation8 as Éµinterpolation8,
  interpolationV as ÉµinterpolationV,
  pipeBind1 as ÉµpipeBind1,
  pipeBind2 as ÉµpipeBind2,
  pipeBind3 as ÉµpipeBind3,
  pipeBind4 as ÉµpipeBind4,
  pipeBindV as ÉµpipeBindV,
  pureFunction0 as ÉµpureFunction0,
  pureFunction1 as ÉµpureFunction1,
  pureFunction2 as ÉµpureFunction2,
  pureFunction3 as ÉµpureFunction3,
  pureFunction4 as ÉµpureFunction4,
  pureFunction5 as ÉµpureFunction5,
  pureFunction6 as ÉµpureFunction6,
  pureFunction7 as ÉµpureFunction7,
  pureFunction8 as ÉµpureFunction8,
  pureFunctionV as ÉµpureFunctionV,
  getCurrentView as ÉµgetCurrentView,
  getHostElement as ÉµgetHostElement,
  restoreView as ÉµrestoreView,
  containerRefreshStart as ÉµcontainerRefreshStart,
  containerRefreshEnd as ÉµcontainerRefreshEnd,
  queryRefresh as ÉµqueryRefresh,
  loadQueryList as ÉµloadQueryList,
  elementEnd as ÉµelementEnd,
  elementProperty as ÉµelementProperty,
  componentHostSyntheticProperty as ÉµcomponentHostSyntheticProperty,
  projectionDef as ÉµprojectionDef,
  reference as Éµreference,
  enableBindings as ÉµenableBindings,
  disableBindings as ÉµdisableBindings,
  allocHostVars as ÉµallocHostVars,
  elementAttribute as ÉµelementAttribute,
  elementContainerStart as ÉµelementContainerStart,
  elementContainerEnd as ÉµelementContainerEnd,
  elementStyling as ÉµelementStyling,
  elementHostAttrs as ÉµelementHostAttrs,
  elementStylingMap as ÉµelementStylingMap,
  elementStyleProp as ÉµelementStyleProp,
  elementStylingApply as ÉµelementStylingApply,
  elementClassProp as ÉµelementClassProp,
  textBinding as ÉµtextBinding,
  template as Éµtemplate,
  embeddedViewEnd as ÉµembeddedViewEnd,
  store as Éµstore,
  load as Éµload,
  pipe as Éµpipe,
  BaseDef as ÉµBaseDef,
  ComponentDef as ÉµComponentDef,
  ComponentDefWithMeta as ÉµComponentDefWithMeta,
  DirectiveDef as ÉµDirectiveDef,
  DirectiveDefWithMeta as ÉµDirectiveDefWithMeta,
  PipeDef as ÉµPipeDef,
  PipeDefWithMeta as ÉµPipeDefWithMeta,
  whenRendered as ÉµwhenRendered,
  i18n as Éµi18n,
  i18nAttributes as Éµi18nAttributes,
  i18nExp as Éµi18nExp,
  i18nStart as Éµi18nStart,
  i18nEnd as Éµi18nEnd,
  i18nApply as Éµi18nApply,
  i18nPostprocess as Éµi18nPostprocess,
  setClassMetadata as ÉµsetClassMetadata,
} from './render3/index';


export {
  compileComponent as ÉµcompileComponent,
  compileDirective as ÉµcompileDirective,
} from './render3/jit/directive';
export {
  compileNgModule as ÉµcompileNgModule,
  compileNgModuleDefs as ÉµcompileNgModuleDefs,
  patchComponentDefWithScope as ÉµpatchComponentDefWithScope,
  resetCompiledComponents as ÉµresetCompiledComponents,
} from './render3/jit/module';
export {
  compilePipe as ÉµcompilePipe,
} from './render3/jit/pipe';

export {
  NgModuleDef as ÉµNgModuleDef,
  NgModuleDefWithMeta as ÉµNgModuleDefWithMeta,
  NgModuleTransitiveScopes as ÉµNgModuleTransitiveScopes,
} from './metadata/ng_module';

export {
  sanitizeHtml as ÉµsanitizeHtml,
  sanitizeStyle as ÉµsanitizeStyle,
  defaultStyleSanitizer as ÉµdefaultStyleSanitizer,
  sanitizeScript as ÉµsanitizeScript,
  sanitizeUrl as ÉµsanitizeUrl,
  sanitizeResourceUrl as ÉµsanitizeResourceUrl,
} from './sanitization/sanitization';

export {
  bypassSanitizationTrustHtml as ÉµbypassSanitizationTrustHtml,
  bypassSanitizationTrustStyle as ÉµbypassSanitizationTrustStyle,
  bypassSanitizationTrustScript as ÉµbypassSanitizationTrustScript,
  bypassSanitizationTrustUrl as ÉµbypassSanitizationTrustUrl,
  bypassSanitizationTrustResourceUrl as ÉµbypassSanitizationTrustResourceUrl,
} from './sanitization/bypass';

export {
  getLContext as ÉµgetLContext
} from './render3/context_discovery';

export {
  Player as ÉµPlayer,
  PlayerFactory as ÉµPlayerFactory,
  PlayState as ÉµPlayState,
  PlayerHandler as ÉµPlayerHandler,
} from './render3/interfaces/player';

export {
  LContext as ÉµLContext,
} from './render3/interfaces/context';

export {
  bindPlayerFactory as ÉµbindPlayerFactory,
} from './render3/styling/player_factory';

export {
  addPlayer as ÉµaddPlayer,
  getPlayers as ÉµgetPlayers,
} from './render3/players';

// we reexport these symbols just so that they are retained during the dead code elimination
// performed by rollup while it's creating fesm files.
//
// no code actually imports these symbols from the @angular/core entry point
export {
  compileNgModuleFactory__POST_R3__ as ÉµcompileNgModuleFactory__POST_R3__
} from './application_ref';
export {
  SWITCH_COMPILE_COMPONENT__POST_R3__ as ÉµSWITCH_COMPILE_COMPONENT__POST_R3__,
  SWITCH_COMPILE_DIRECTIVE__POST_R3__ as ÉµSWITCH_COMPILE_DIRECTIVE__POST_R3__,
  SWITCH_COMPILE_PIPE__POST_R3__ as ÉµSWITCH_COMPILE_PIPE__POST_R3__,
} from './metadata/directives';
export {
  SWITCH_COMPILE_NGMODULE__POST_R3__ as ÉµSWITCH_COMPILE_NGMODULE__POST_R3__,
} from './metadata/ng_module';
export {
  getDebugNode__POST_R3__ as ÉµgetDebugNode__POST_R3__,
} from './debug/debug_node';
export {
  SWITCH_COMPILE_INJECTABLE__POST_R3__ as ÉµSWITCH_COMPILE_INJECTABLE__POST_R3__,
} from './di/injectable';
export {
  SWITCH_IVY_ENABLED__POST_R3__ as ÉµSWITCH_IVY_ENABLED__POST_R3__,
} from './ivy_switch';
export {
  SWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__ as ÉµSWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__,
} from './change_detection/change_detector_ref';
export {
  Compiler_compileModuleSync__POST_R3__ as ÉµCompiler_compileModuleSync__POST_R3__,
  Compiler_compileModuleAsync__POST_R3__ as ÉµCompiler_compileModuleAsync__POST_R3__,
  Compiler_compileModuleAndAllComponentsSync__POST_R3__ as ÉµCompiler_compileModuleAndAllComponentsSync__POST_R3__,
  Compiler_compileModuleAndAllComponentsAsync__POST_R3__ as ÉµCompiler_compileModuleAndAllComponentsAsync__POST_R3__,
} from './linker/compiler';
export {
  SWITCH_ELEMENT_REF_FACTORY__POST_R3__ as ÉµSWITCH_ELEMENT_REF_FACTORY__POST_R3__,
} from './linker/element_ref';
export {
  SWITCH_TEMPLATE_REF_FACTORY__POST_R3__ as ÉµSWITCH_TEMPLATE_REF_FACTORY__POST_R3__,
} from './linker/template_ref';
export {
  SWITCH_VIEW_CONTAINER_REF_FACTORY__POST_R3__ as ÉµSWITCH_VIEW_CONTAINER_REF_FACTORY__POST_R3__,
} from './linker/view_container_ref';
export {
  SWITCH_RENDERER2_FACTORY__POST_R3__ as ÉµSWITCH_RENDERER2_FACTORY__POST_R3__,
} from './render/api';

export {getModuleFactory__POST_R3__ as ÉµgetModuleFactory__POST_R3__} from './linker/ng_module_factory_loader';

export {
  publishGlobalUtil as ÉµpublishGlobalUtil,
  publishDefaultGlobalUtils as ÉµpublishDefaultGlobalUtils
} from './render3/global_utils';
export {
  SWITCH_INJECTOR_FACTORY__POST_R3__ as ÉµSWITCH_INJECTOR_FACTORY__POST_R3__,
} from './di/injector';

// clang-format on
